export enum IMAGE_STATUS {
  INITIAL = "initial",
  LOADING = "loading",
  LOADED = "loaded",
  ERROR = "error",
}

export enum OrganizationType {
  GENERAL = "general",
  QUANTITY_SURVEYOR = "quantity_surveyor",
}

export enum OrganizationRole {
  ADMIN = "admin",
  MEMBER = "member",
}

export enum StatusEnum {
  CREATED = "created",
  IN_PROCESS = "in_process",
  IN_VALIDATION = "in_validation",
  ERROR = "error",
  DONE = "done",
}

export enum PublishStatus {
  UNPUBLISHED = "unpublished",
  PUBLISHED = "published",
}

export const DEFAULT_MAP_ELEMENT_RGB: [number, number, number] = [118, 0, 255];

// A marker with no stated multiplier represents exactly one element.
export const DEFAULT_ELEMENT_MULTIPLIER = 1;
